import { ResellerLevelInfo } from '@/interfaces/IResellerLevels';
import { RESELLER_LEVELS } from '../constants/resellerLevels';

export const getResellerLevel = (totalClients: number): ResellerLevelInfo => {
	if (!totalClients || totalClients <= 0) {
		return {
			currentLevel: RESELLER_LEVELS[0].level,
			nextLevel: RESELLER_LEVELS[1]?.level || 'Max Level Reached',
			nextLevelSeats: RESELLER_LEVELS[1]?.min || 0,
		};
	}

	let currentLevel = RESELLER_LEVELS[0].level;
	let nextLevel = 'Max Level Reached';
	let nextLevelSeats = 0;

	for (let i = 0; i < RESELLER_LEVELS.length; i++) {
		const { level, min, max } = RESELLER_LEVELS[i];

		if (totalClients >= min && totalClients <= max) {
			currentLevel = level;

			if (i + 1 < RESELLER_LEVELS.length) {
				nextLevel = RESELLER_LEVELS[i + 1].level;
				nextLevelSeats = RESELLER_LEVELS[i + 1].min - totalClients;
			} else {
				nextLevel = 'Max Level Reached';
				nextLevelSeats = 0;
			}
			break;
		}
	}

	return { currentLevel, nextLevel, nextLevelSeats };
};

export const calculateProfit = (seats: number, seatPrice: number, costPerSeat: number = 55) => {
	const profitPerSeat = seatPrice - costPerSeat;
	const monthlyProfit = seats * profitPerSeat;
	const annualProfit = monthlyProfit * 12;

	return {
		profitPerSeat,
		monthlyProfit,
		annualProfit,
	};
};

export const formatCurrency = (amount: number): string => {
	return `$${amount.toLocaleString('en-US')}`;
};
